import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../service";

const initialState: any = {
  listItems: [],

  activeItem: {},
  loading: false,
  activeItemloading: false,
};
export const getAttitudeToRiskCategoriesListItems = createAsyncThunk(
  "attitudeToRiskCategories/getAttitudeToRiskCategoriesListItems",
  async (_, { rejectWithValue }) => {
    try {
      const response: any =
        await apiServices.systemManager.attitudeToRiskcategory.getList();
      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch  list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getAttitudeToRiskCategoryDetailById = createAsyncThunk(
  "attitudeToRiskCategory/getAttitudeToRiskCategoryDetailById",
  async (Id: string, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid Id ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.attitudeToRiskCategories.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find((item: any) => item.id === Id);
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);

export const attitudeToRiskCategoriesSlice = createSlice({
  name: "attitudeToRiskCategories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAttitudeToRiskCategoriesListItems.pending, (state) => {
        state.loading = true;
        state.listItems = [];
      })
      .addCase(
        getAttitudeToRiskCategoriesListItems.fulfilled,
        (state, action) => {
          state.loading = false;
          state.listItems = action.payload;
        }
      )
      .addCase(
        getAttitudeToRiskCategoriesListItems.rejected,
        (state, action) => {
          state.loading = false;
          console.error("Error fetching  list:", action.payload);
        }
      )
      .addCase(getAttitudeToRiskCategoryDetailById.pending, (state) => {
        state.activeItemloading = true;
        state.activeItem = {};
      })
      .addCase(
        getAttitudeToRiskCategoryDetailById.fulfilled,
        (state, action) => {
          state.activeItemloading = false;
          state.activeItem = action.payload;
        }
      )
      .addCase(
        getAttitudeToRiskCategoryDetailById.rejected,
        (state, action) => {
          state.activeItemloading = false;
          console.error("Error fetching  details:", action.payload);
        }
      );
  },
});
export const {} = attitudeToRiskCategoriesSlice.actions;
export default attitudeToRiskCategoriesSlice.reducer;
